import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Paper,
  TextField,
  Typography
} from '@material-ui/core';
import api from 'services/api';
import PropTypes from 'prop-types';
import { ANAO, ASIM } from 'consts';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

const ROTA_LISTA = '/crm/whatsapp/grupos';

const PROPS_INPUT_NOME = {
  style: { textTransform: 'uppercase' }
};

/* Retorna o grupo com o nome em caixa alta */
const normalizarGrupo = (grupo) => ({
  ...grupo,
  nome: String(grupo.nome || '').toUpperCase()
});

export default function GrupoMsgWhatsAppPassageiroForm({
  modal = false,
  open = true,
  registro = null,
  onClose,
  onSaved
}) {
  const history = useHistory();
  const { id } = useParams();

  const [dados, setDados] = useState({});
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const titulo = `${dados.idgrupomsgwhats ? 'Alterar' : 'Novo'} grupo`;

  /* Carrega os dados iniciais da tela */
  useEffect(() => {
    if (!open) return;

    let active = true;

    setErro('');

    if (modal) {
      setDados(registro ? normalizarGrupo(registro) : {});

      return;
    }

    if (!id || id === 'novo') {
      setDados({});

      return;
    }

    api.get('/crm/whatsapp/grupos').then(response => {
      if (!active) return;

      const grupos = Array.isArray(response.data) ? response.data : [];
      const item = grupos.find(x => String(x.idgrupomsgwhats) === String(id));

      if (item) {
        setDados(normalizarGrupo(item));
      } else {
        setErro('Registro não encontrado!');
      }
    }).catch(() => {
      if (active) setErro('Não foi possível consultar o cadastro!');
    });

    return () => {
      active = false;
    };
  }, [open, modal, registro, id]);

  /* Altera o campo do grupo */
  const alterar = (campo, valor) => {
    setDados(d => ({
      ...d,
      [campo]: valor
    }));
  };

  /* Evento onChange dos componentes */
  const onChangeNome = (event) => alterar('nome', event.target.value.toUpperCase());
  const onChangeInativo = (event) => alterar('inativo', event.target.checked ? ASIM : ANAO);

  /* Fecha o modal ou volta para a consulta */
  const voltar = () => {
    if (modal) {
      if (onClose) onClose();
    } else {
      history.push(ROTA_LISTA);
    }
  };

  /* Clicar para salvar */
  const salvar = async () => {
    if (loading) return;

    setLoading(true);
    setErro('');

    try {
      const payload = {
        nome: (dados.nome || '').trim().toUpperCase(),
        inativo: dados.inativo === ASIM ? ASIM : ANAO
      };

      if (dados.idgrupomsgwhats) {
        await api.put(`/crm/whatsapp/grupos/${dados.idgrupomsgwhats}`, payload);
      } else {
        await api.post('/crm/whatsapp/grupos', payload);
      }

      if (onSaved) await onSaved();

      voltar();
    } catch (e) {
      setErro(e.response?.data?.error || 'Não foi possível salvar o cadastro!');
    } finally {
      setLoading(false);
    }
  };

  const conteudo = (
    <>
      {erro && (
        <Typography color="error">
          {erro}
        </Typography>
      )}

      <TextField
        fullWidth
        margin="dense"
        label="Nome do grupo"
        value={dados.nome || ''}
        onChange={onChangeNome}
        inputProps={PROPS_INPUT_NOME}
      />

      <FormControlLabel
        label="Inativo"
        control={
          <Checkbox
            checked={dados.inativo === ASIM}
            onChange={onChangeInativo}
          />
        }
      />
    </>
  );

  const acoes = (
    <>
      <Button onClick={voltar}>
        Cancelar
      </Button>

      <Button
        variant="contained"
        color="primary"
        disabled={loading || !(dados.nome || '').trim()}
        onClick={salvar}
      >
        {loading ? <CircularProgress size={18} /> : 'Salvar'}
      </Button>
    </>
  );

  if (modal) {
    return (
      <Dialog
        open={open}
        onClose={voltar}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {titulo}
        </DialogTitle>

        <DialogContent dividers>
          {conteudo}
        </DialogContent>

        <DialogActions>
          {acoes}
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Box p={3}>
      <Paper style={{ padding: 24 }}>
        <Typography variant="h6">
          {titulo}
        </Typography>

        {conteudo}

        <Box
          mt={2}
          display="flex"
          justifyContent="flex-end"
        >
          {acoes}
        </Box>
      </Paper>
    </Box>
  );
};

GrupoMsgWhatsAppPassageiroForm.propTypes = {
  modal: PropTypes.bool,
  open: PropTypes.bool,
  registro: PropTypes.object,
  onClose: PropTypes.func,
  onSaved: PropTypes.func
};